//
//
//
//
//
//
//
//
//
//
//
import utils from '../../services/utils';
export default {
  name: 'SpringSpinner',
  props: {
    animationDuration: {
      type: Number,
      "default": 3000
    },
    size: {
      type: Number,
      "default": 70
    },
    color: {
      type: String,
      "default": '#fff'
    }
  },
  data: function data() {
    return {
      animationName: "spring-spinner-animation-".concat(Date.now())
    };
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: "".concat(this.size, "px"),
        width: "".concat(this.size, "px")
      };
    },
    spinnerPartStyle: function spinnerPartStyle() {
      return {
        height: "".concat(this.size / 2, "px"),
        width: "".concat(this.size, "px")
      };
    },
    rotatorStyle: function rotatorStyle() {
      return {
        height: "".concat(this.size, "px"),
        width: "".concat(this.size, "px"),
        borderRightColor: this.color,
        borderTopColor: this.color,
        borderWidth: "".concat(this.size / 7, "px"),
        animationDuration: "".concat(this.animationDuration, "ms"),
        animationName: this.animationName
      };
    }
  },
  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    },
    color: {
      handler: 'updateAnimation',
      immediate: true
    }
  },
  mounted: function mounted() {
    this.updateAnimation();
  },
  beforeDestroy: function beforeDestroy() {
    utils.removeKeyframes(this.animationName);
  },
  methods: {
    updateAnimation: function updateAnimation() {
      utils.removeKeyframes(this.animationName);
      utils.appendKeyframes(this.animationName, this.generateKeyframes());
    },
    generateKeyframes: function generateKeyframes() {
      return "\n        0% {\n          border-width: ".concat(this.size / 7, "px;\n        }\n        25% {\n          border-width: ").concat(this.size / 23.33, "px;\n        }\n        50% {\n          transform: rotate(115deg);\n          border-width: ").concat(this.size / 7, "px;\n        }\n        75% {\n          border-width: ").concat(this.size / 23.33, "px;\n         }\n        100% {\n         border-width: ").concat(this.size / 7, "px;\n        }");
    }
  }
};